import React from 'react';

const ICON_ID = 'icon-pencil';

const IconPencil = function(props) {
  return (
    <svg width="20" height="20" viewBox="0 0 13 16" aria-labelledby={ICON_ID}>
      <title id={ICON_ID}>Pencil Icon</title>
      <path d="M8.229 0L0 12.04.305 16l3.81-1.219L12.19 2.743 8.23 0zm-.915 2.895L8.381 1.22l2.59 1.676-1.066 1.678-2.59-1.678zM1.22 11.733l5.638-8.076 2.59 1.676-5.637 8.23-2.591-1.83zm-.305.915l2.134 1.373-1.981.76-.153-2.133z" fill="#00A1E1" fillRule="evenodd"/>
    </svg>
  )
}

export default IconPencil;



// WEBPACK FOOTER //
// ./src/client/components/icons/icon-pencil.jsx